export default "__VITE_ASSET__D98HaORl__"